type Props = {
  text: string;
  tone?: "loading" | "error";
  onRetry?: () => void;
};

/** Thông điệp trạng thái (đang tải / lỗi) bằng tiếng Việt, kèm nút thử lại khi cần. */
export default function StatusMessage({ text, tone = "loading", onRetry }: Props) {
  return (
    <div className={`status-message status-${tone}`} role="status">
      {tone === "loading" ? <span className="spinner" aria-hidden="true" /> : <span aria-hidden="true">⚠️</span>}
      <p>{text}</p>
      {onRetry ? (
        <button type="button" className="btn btn-secondary" onClick={onRetry}>
          Thử lại
        </button>
      ) : null}
    </div>
  );
}
